import { gql } from "@apollo/client/core"
import { useMutation, InjectedOptions } from "@oysterhr/core"
import { AddOnStartTrialInput, AddOnStartTrialPayload } from "@oysterhr/schema"
import { noop as setPayloadErrorsHook } from "lodash-es"

const MUTATION = gql`
  mutation AddOnStartTrial($input: AddOnStartTrialInput!) {
    addOnStartTrial(input: $input) {
      errors
      addOn {
        startsOn
        plan {
          name
          description
        }
      }
    }
  }
`

export const useAddOnStartTrial = (
  options?: InjectedOptions<
    { addOnStartTrial: AddOnStartTrialPayload },
    { input: AddOnStartTrialInput }
  >,
) => useMutation(MUTATION, { ...options, setPayloadErrorsHook })
